// Imports
  // React
  import { useState } from 'react'
  import { Link, useNavigate } from 'react-router-dom'
  // Firebase
  import { uploadPicture, newItem } from "../firebase/FirebaseClient"
  //Icons
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
  import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'




// rafce

const ItemNew = (  ) => {

    // New item

      const [product, setproduct] = useState({ code: "", name: "", description:"" , picture: "", price: "", stock: "" })
      const [category, setCategory] = useState([])

      const navigate = useNavigate()

      // Handle Categories
      const handleCheckboxes = () => {
        const checkboxes = document.querySelectorAll('input[type=checkbox]')
        for(let i=0; i<checkboxes.length; i++){
          if(checkboxes[i].checked == true){
              category.push(checkboxes[i].value)
          }
         }
      }

      // Bring info from form
        const newItemInfo = (event) => {
          setproduct({
            ...product,
            [event.target.name] : event.target.value
          })
        }

      // Bring picture from form
        const [uploadedPicture, setUploadedPicture] = useState(null)

      // Create item
        const [ loading, setLoading ] = useState(false);
        const newItemSubmit = async(event) => { 
          event.preventDefault();
          setLoading(true)
          document.getElementsByClassName("admin-wait")[0].removeAttribute("style")
          document.getElementsByClassName("admin-form-buttons")[0].setAttribute("style", "display: none;")
          handleCheckboxes()
          try {
            const pictureUrl = await uploadPicture(uploadedPicture);
            newItem(product.code,
                    category,
                    product.name,
                    product.description,
                    pictureUrl,
                    product.price,
                    product.stock);
          } catch (error) {
            alert("La imagen no se subió correctamente, por favor intente de nuevo")  
          }
          setLoading(false)
          setUploadedPicture(null)
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          navigate(`/admin/productos`)
        }

      
       
  
	// Component
  return (
    <>
      <div className='main-admin'>
        <Link to="/admin/productos/"><FontAwesomeIcon icon={ faRightFromBracket } flip="horizontal" size="2x" /></Link>
        <form className="admin-form" onSubmit={newItemSubmit}>
          <span>Crear Producto</span>
          <ul className='admin-form-categories'>
            <li>
              <input
                type="checkbox"
                name="category"
                value="fluo"
                id="fluo" />
                <label htmlFor='fluo'>Artículos Fluo</label>
            </li>
            <li>
              <input
                type="checkbox"
                name="category"
                value="deluxe"
                id="deluxe" />
                <label htmlFor='deluxe'>Artículos Deluxe</label>
            </li>
            <li>
              <input
                type="checkbox"
                name="category"
                value="luminicos"
                id="luminicos" />
                <label htmlFor='luminicos'>Lumínicos</label>
            </li>
            <li>
              <input
                type="checkbox"
                name="category"
                value="futbol"
                id="futbol" />
                <label htmlFor='futbol'>Gorros Fútbol</label>
            </li>
            <li>
              <input
                type="checkbox"
                name="category"
                value="vinchas"
                id="vinchas" />
                <label htmlFor='vinchas'>Vinchas</label>
            </li>
            <li>
              <input
                type="checkbox"
                name="category"
                value="accesorios"
                id="accesorios" />
                <label htmlFor='accesorios'>Accesorios</label>
            </li>
          </ul>
          <input
                className="admin-form-text-box"
                name="code"
                type="text"
                maxLength={4}
                required
                placeholder="Ingrese el código del producto..."
                onChange={newItemInfo} />
          <input
                className="admin-form-text-box"
                name="name"
                type="text"
                required
                placeholder="Ingrese el nombre del producto..."
                onChange={newItemInfo} />
          <input
                className="admin-form-text-box"
                name="description"
                type="text"
                maxLength={75}
                required
                placeholder="Ingrese una breve descripción..."
                onChange={newItemInfo} />
          <input
                className="admin-form-text-box"
                name="picture"
                type="file"
                onChange={ (event) => setUploadedPicture(event.target.files[0]) } />
          <input
                className="admin-form-text-box"
                name="price"
                type="number"
                step="0.01"
                onWheel={e => e.target.blur()}
                required
                placeholder="Ingrese el precio del producto..."
                onChange={newItemInfo} />
          <input
                className="admin-form-text-box"
                name="stock"
                type="number"
                onWheel={e => e.target.blur()}
                required
                placeholder="Ingrese el stock disponible..."
                onChange={newItemInfo} />
          <p className='admin-wait' style={{display:"none"}}>Por favor aguarde...</p>
          <div className='admin-form-buttons'>
            <input className="admin-item-button" type="submit" name="send" value="Crear Item" disabled={loading}></input>
            <input className="admin-item-button" type="reset" name="reset" value="Borrar Datos"></input>
          </div>
        </form>
       </div> 
    </>
  )
  
}

export default ItemNew

